<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <p class="text-lg my-2 font-medium">Share your link with customers whenever they interact with your business!</p>
    <p class="my-2 mb-4 text-lg">You can use your QR code to make visiting your feedback link easier. <a href="https://www.dummies.com/business/marketing/social-media-marketing/how-to-scan-a-qr-code/" target="_blank">What is a QR Code?</a></p>
    <vx-card class="text-center mb-base md:py-20">
    <div class="vx-row flex">
      <div class="vx-col w-full lg:w-1/2">
        <div class="my-10">
        <feather-icon icon="LinkIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-5 w-5"></feather-icon>
        <p class="text-lg">Your feedback link is</p>
        <vs-button class="px-0 mx-auto lg:text-4xl" type="flat" size="large" :href="$store.getters['dash/feedbackURLTest']" target="_blank" icon-pack="feather" icon="icon-external-link" icon-after>{{ $store.getters['dash/feedbackURL'] }}</vs-button>
        </div>
      </div>
      <div class="vx-col w-full lg:w-1/2 ">
        <h3 class="text-center mb-5">QR Code</h3>
        <div class="overflow-auto">
          <div class="w-full md:w-1/2 float-left">
            <img class="w-2/3 p-4 mx-auto" style="max-width: 300px;" :src="$store.getters['dash/qrfbl64']"/>
          </div>
          <div class="w-full md:w-1/2 float-left text-left pr-8">
            <p class="mt-5">Anyone can scan this QR code with their smartphone, and it will direct them to your feedback link.</p>
            <p class="mt-5 text-sm">Click below to download, or right click and "Save Image as" to save to your computer.</p>
            <vs-button class="my-2" type="border"  icon-pack="feather" icon="icon-download" @click="downloadFBLQR">Download QR Code</vs-button>
          </div>
        </div>
      </div>
    </div>
    </vx-card>

    <div class="vx-row">

      <div class="vx-col w-full">
          <div class="text-center my-8">
            <p class="mx-auto max-w-sm mb-5 text-lg">Your feedback surveys works on all modern smartphone, tablet and computer web browsers.</p>
            <img src="@/assets/images/misc/alldevices.png" class="w-40" >
          </div>
      </div>



    </div>

  </div>
</template>


<script>



export default {
  data () {
    return {

    }
  },
  components: {

  },
  methods: {
    downloadFBLQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrfbl64'];
      link.download = 'Feedback Link QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    /*downloadHappyQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrhappy64'];
      link.download = 'Direct Reviews QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadUnhappyQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrunhappy64'];
      link.download = 'Direct Complaints QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }*/
  },
  created () {
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
